export const openLink = (link) => {
    window.open(link, '_blank');
};
